import Store from '@store';
import { getLargestNumberFromObjectKey } from 'src/utils/format';

export class BulletListFactory {
  #store;

  constructor () {
    this.#store = Store;
  }

  #getStyleId () {
    const charStylesData = this.#store.getState().metadata.bullet_and_ordered_list?.character_styles;
    const bulletListStyleData = this.#store.getState().text.bulletList.styles;

    return {
      bulletList: getLargestNumberFromObjectKey(bulletListStyleData),
      character: charStylesData
        ? getLargestNumberFromObjectKey(charStylesData)
        : 0
    };
  }

  updateExistingMetadata (selectedBulletStyle, selectedValues) {
    const metadata = this.#store.getState().metadata.bullet_and_ordered_list;
    const listStyleMetadata = metadata.bullet_list_styles;
    const characterStyleMetadata = metadata.character_styles;
    const listStyle = listStyleMetadata[selectedBulletStyle];
    const updatedListStyle = {};
    const updatedCharacterStyles = {};
    let { character: characterStyleId } = this.#getStyleId();

    for (const [index, value] of selectedValues.entries()) {
      const characterStyle = listStyle.character_styles[index];

      if (!characterStyle) {
        characterStyleId += 1;
        updatedCharacterStyles[characterStyleId] = {
          char_code: value
        };
      } else {
        updatedCharacterStyles[characterStyle] = {
          ...characterStyleMetadata[characterStyle],
          char_code: value
        };
      }
    }

    updatedListStyle[selectedBulletStyle] = { ...listStyle, character_styles: Object.keys(updatedCharacterStyles) };

    return {
      bullet_and_ordered_list: {
        ...metadata,
        bullet_list_styles: { ...listStyleMetadata, ...updatedListStyle },
        character_styles: { ...characterStyleMetadata, ...updatedCharacterStyles }
      }
    };
  }

  createNewMetadata (selectedValues) {
    const metadata = this.#store.getState().metadata.bullet_and_ordered_list;
    const characterStyles = {};
    const listStyles = {};
    let { bulletList: listStyleId, character: characterStyleId } = this.#getStyleId();

    for (const value of selectedValues) {
      characterStyleId += 1;
      characterStyles[characterStyleId] = {
        char_code: value
      };
    }

    listStyles[listStyleId + 1] = {
      name: `Custom bullet list style ${listStyleId + 1}`,
      character_styles: Object.keys(characterStyles)
    };

    return {
      bullet_and_ordered_list: {
        ...metadata,
        bullet_list_styles: { ...metadata?.bullet_list_styles, ...listStyles },
        character_styles: { ...metadata?.character_styles, ...characterStyles }
      }
    };
  }
}
